// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1SjS_","filesListContainer":"PosDisputesFiles_filesListContainer__86yMW","filesButton":"PosDisputesFiles_filesButton__3gi4B"};